var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9168 4.66675H11.0835L8.16683 8.16675H4.66683C4.04799 8.16675 3.4545 8.41258 3.01691 8.85017C2.57933 9.28775 2.3335 9.88124 2.3335 10.5001V21.0001C2.3335 21.6189 2.57933 22.2124 3.01691 22.65C3.4545 23.0876 4.04799 23.3334 4.66683 23.3334H23.3335C23.9523 23.3334 24.5458 23.0876 24.9834 22.65C25.421 22.2124 25.6668 21.6189 25.6668 21.0001V10.5001C25.6668 9.88124 25.421 9.28775 24.9834 8.85017C24.5458 8.41258 23.9523 8.16675 23.3335 8.16675H19.8335L16.9168 4.66675Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.6667C15.933 18.6667 17.5 17.0997 17.5 15.1667C17.5 13.2338 15.933 11.6667 14 11.6667C12.067 11.6667 10.5 13.2338 10.5 15.1667C10.5 17.0997 12.067 18.6667 14 18.6667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f48568e2d07716ca2b85c42f8df9f573.svg";
export { ForwardRef as ReactComponent };